export class DateUtil {
    static formatDate(timeStamp) {
        const date = new Date(timeStamp);
        const month = date.toLocaleString("en-US", { month: "long" });
        return `${month} ${date.getDate()}, ${date.getFullYear()}`;
    }
}
